import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
const WorkshopsPage = () => {
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-589">
      <Header data-id="element-590" />
      <main className="flex min-h-screen pt-24 px-6 pb-16" data-id="element-591">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-592">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-593">
            <Navigation data-id="element-594" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8" data-id="element-595">
            <div className="max-w-2xl" data-id="element-596">
              <div className="mb-8" data-id="element-597">Workshops for 2026</div>
              <div className="mb-8" data-id="element-598">
                <div className="mb-1" data-id="element-599">
                  The Winter Practice Workshop (Online)
                </div>
                <div className="mb-1" data-id="element-600">Saturdays 9am - 12pm EST</div>
                <div className="mb-1" data-id="element-601">January 24th - February 21st, 2026</div>
                <Link to="/winter-practice-workshop" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-602">
                  Register here
                </Link>
              </div>
              <div className="mb-8" data-id="element-603">
                <div className="mb-1" data-id="element-604">
                  Try Something New: 100 Images in Two Days
                </div>
                <div className="mb-1" data-id="element-605">
                  In-Person @{' '}
                  <a href="https://www.penumbrafoundation.org/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-606">
                    Penumbra Foundation
                  </a>
                </div>
                <div className="mb-1" data-id="element-607">April 22nd - April 24th, 2026</div>
                <a href="https://www.penumbrafoundation.org/workshops/try-something-new-100-images-in-two-days" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-608">
                  Register here
                </a>
              </div>
              <div className="mb-8" data-id="element-609">
                <div className="mb-1" data-id="element-610">
                  The Sum of the Parts: A Writing and Photography Workshop
                </div>
                <div className="mb-1" data-id="element-611">
                  Co-led by{' '}
                  <a href="https://www.vivianewing.com/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-612">
                    Vivian Ewing
                  </a>
                </div>
                <div className="mb-1" data-id="element-613">
                  In-Person @{' '}
                  <a href="https://www.mainemedia.edu/workshops/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-614">
                    Maine Media Workshops
                  </a>
                </div>
                <div className="mb-1" data-id="element-615">August 24th - August 28th, 2026</div>
                <div data-id="element-616">Details Coming Soon</div>
              </div>
              <div className="mb-8" data-id="element-617">
                <div className="mb-1" data-id="element-618">
                  Photography & Storytelling: Thinking About the Photo Book
                </div>
                <div className="mb-1" data-id="element-619">
                  In-Person @{' '}
                  <a href="https://www.mainemedia.edu/workshops/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-620">
                    Maine Media Workshops
                  </a>
                </div>
                <div className="mb-1" data-id="element-621">
                  September 21st - September 25th, 2026
                </div>
                <div data-id="element-622">Details Coming Soon</div>
              </div>
              <div className="mb-12" data-id="element-623">
                <div data-id="element-624">
                  One-on-one mentorship follows the{' '}
                  <a href="https://santafeworkshops.com/sfw-online/mentorships/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-625">
                    Santa Fe Mentorship Level 1
                  </a>{' '}
                  model. Email me directly to enquire.
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default WorkshopsPage;